import Marionette from "marionette";
import CamPhotoItemView from "./CamPhotoItemView";
import "css!classes/modals/cam/view/css/CamPhotoCompositeView";
import template from "classes/modals/cam/view/template/CamPhotoCompositeView.html";


let CamPhotoCompositeView = Marionette.CompositeView.extend("CamPhotoCompositeView", {
    template,
    childView: CamPhotoItemView,
    childViewContainer: "ul",

    ui: {
        $selectButton: ".CamPhotoSelectItem span"
    },

    childEvents: {
        click: "onClickPhoto",
        remove: "onRemovePhoto"
    },

    modelEvents: {
        "change:selected": "onChangeSelected"
    },

    events: {
        "click @ui.$selectButton": "onClickSelectButton"
    },

    onClickPhoto(view) {
        let lastView = this.getSelectedView();
        this.model.set("selected", view.model.cid);

        if ( lastView ) {
            lastView.$el.removeClass("selected");
        }

        view.$el.addClass("selected");
        this.trigger("showPhoto", view.model);
    },

    onRemovePhoto(view) {
        let cid = view.model.cid;
        if ( cid == this.model.get("selected") ) {
            this.model.set("selected", false);
        }
    },

    getSelectedView() {
        let cid = this.model.get("selected");
        let selected;
        this.children.each(function(view) {
            if ( view.model.cid == cid ) {
                selected = view;
            }
        }.bind(this));
        return selected;
    },

    onChangeSelected() {
        let cid = this.model.get("selected");

        if ( this.ui && this.ui.$selectButton ) {
            if ( cid ) {
                this.ui.$selectButton.removeClass("btn-default");
                this.ui.$selectButton.addClass("btn-success");
            } else {
                this.ui.$selectButton.addClass("btn-default");
                this.ui.$selectButton.removeClass("btn-success");
            }
        }
    },

    onClickSelectButton(e) {
        e.preventDefault();
        let view = this.getSelectedView();
        if ( !view ) {
            return;
        }

        this.trigger("select", view.model);
    }
});

export default CamPhotoCompositeView;
